import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=d0d1d4fe&scoped=true"
import script from "./RegisterForm.vue?vue&type=script&lang=ts"
export * from "./RegisterForm.vue?vue&type=script&lang=ts"
import style0 from "./RegisterForm.vue?vue&type=style&index=0&id=d0d1d4fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d1d4fe",
  null
  
)

export default component.exports